export default __webpack_public_path__ + "static/media/2.2b77d1f1.svg";